import { useState } from "react";
import { categories, categoryArticles } from "@/mocks/media";

export default function ColumnSection() {
  const [active, setActive] = useState(categories[0].key);
  const cat = categories.find((c) => c.key === active) ?? categories[0];
  const items = categoryArticles[cat.key] ?? [];

  return (
    <section className="relative py-12 md:py-16 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {categories.map((c) => (
          <span key={c.key} id={c.key} className="absolute top-0 h-px w-px"></span>
        ))}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-5">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-primary-600">COLUMNS</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">吃瓜栏目导航</h2>
            <p className="mt-3 text-foreground-600 max-w-2xl">
              六个栏目，六大视角。点选任意栏目，浏览该主题下的最新盘点与独家观察。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {categories.map((c) => {
            const isActive = c.key === active;
            return (
              <button
                key={c.key}
                type="button"
                onClick={() => setActive(c.key)}
                className={`flex flex-col items-start gap-2 p-4 rounded-lg border text-left transition-colors ${
                  isActive
                    ? "border-primary-600 bg-primary-600 text-background-50"
                    : "border-background-200 bg-background-50 hover:border-primary-300"
                }`}
              >
                <span className={`w-9 h-9 rounded-md flex items-center justify-center text-lg ${isActive ? "bg-background-50/20 text-background-50" : "bg-primary-100 text-primary-600"}`}>
                  <i className={c.icon}></i>
                </span>
                <span className="text-sm font-semibold">{c.name}</span>
                <span className={`text-[10px] tracking-widest ${isActive ? "text-background-50/70" : "text-foreground-400"}`}>
                  {c.en}
                </span>
              </button>
            );
          })}
        </div>

        <div key={cat.key} className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {items.map((a, idx) => (
            <article
              key={a.id}
              className="group bg-background-50 rounded-lg p-5 flex flex-col hover:shadow-sm border border-background-200"
            >
              <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600">
                <i className={`ri-award-line ${idx === 0 ? "" : "opacity-0"}`}></i>
                {cat.name}
              </span>
              <h3 className="mt-3 font-heading font-bold text-lg leading-snug text-foreground-900 group-hover:text-primary-600">
                <a href={`#${cat.key}`} className="hover:text-primary-600">{a.title}</a>
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{a.excerpt}</p>
              <div className="mt-5 flex items-center gap-3 text-xs text-foreground-400">
                <span className="inline-flex items-center gap-1"><i className="ri-user-3-line"></i>{a.author}</span>
                <span>{a.time}</span>
                <span className="ml-auto inline-flex items-center gap-1"><i className="ri-eye-line"></i>{a.reads}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}